import { v4 as uuid } from "uuid";

import {
  Sunscreen1,
  Sunscreen2,
  Sunscreen3,
  Serum1,
  Serum2,
  Serum3,
  Moisturizer1,
  Moisturizer2,
  Moisturizer3,
  Cleanser1,
  Cleanser2,
  Cleanser3,
  Bodycare1,
  Bodycare2,
  Bodycare3,
  Bodycare4,
  Bodycare5
} from '../../assets';

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: "NoSebum Sunscreen SPF50+",
    brand: "Innisfree",
    rating: 4.2,
    reviews: 324,
    discountPrice: 750,
    originalPrice: 900,
    discountRate: 16,
    tag: "Best Seller",
    inStock: true,
    coverImg: Sunscreen1,
    categoryName: "Sunscreen",
  },
  {
    _id: uuid(),
    name: "Hyaluronic AquaGel SPF50",
    brand: "The Derma Co.",
    rating: 4.5,
    reviews: 103,
    discountPrice: 474,
    originalPrice: 499,
    discountRate: 5,
    tag: "Best Seller",
    inStock: true,
    coverImg: Sunscreen2,
    categoryName: "Sunscreen",
  },
  {
    _id: uuid(),
    name: "Multivitamin SPF50",
    brand: "Minimalist",
    rating: 4.3,
    reviews: 900,
    discountPrice: 320,
    originalPrice: 399,
    discountRate: 19,
    tag: "",
    inStock: false,
    coverImg: Sunscreen3,
    categoryName: "Sunscreen",
  },
  {
    _id: uuid(),
    name: "2% Salicylic Acid for Acne",
    brand: "The Derma Co.",
    rating: 3.5,
    reviews: 572,
    discountPrice: 464,
    originalPrice: 499,
    discountRate: 7,
    tag: "Freebies",
    inStock: true,
    coverImg: Serum1,
    categoryName: "Serums",
  },
  {
    _id: uuid(),
    name: "Pure Vitamin C Serum",
    brand: "Klairs",
    rating: 4.8,
    reviews: 2254,
    discountPrice: 1413,
    originalPrice: 1570,
    discountRate: 10,
    tag: "Best Seller",
    inStock: true,
    coverImg: Serum2,
    categoryName: "Serums",
  },
  {
    _id: uuid(),
    name: "1% Retinol Face Serum",
    brand: "Plum",
    rating: 2.7,
    reviews: 24,
    discountPrice: 530,
    originalPrice: 550,
    discountRate: 3,
    tag: "",
    inStock: true,
    coverImg: Serum3,
    categoryName: "Serums",
  },
  {
    _id: uuid(),
    name: "Moisture Surge 100h",
    brand: "Clinique",
    rating: 4.4,
    reviews: 5372,
    discountPrice: 900,
    originalPrice: 950,
    discountRate: 5,
    tag: "",
    inStock: true,
    coverImg: Moisturizer1,
    categoryName: "Moisturizers",
  },
  {
    _id: uuid(),
    name: "Hydro Boost Water Gel",
    brand: "Neutrogena",
    rating: 3.8,
    reviews: 7002,
    discountPrice: 850,
    originalPrice: 900,
    discountRate: 5,
    tag: "",
    inStock: true,
    coverImg: Moisturizer2,
    categoryName: "Moisturizers",
  },
  {
    _id: uuid(),
    name: "Snail 92 All In One Cream",
    brand: "COSRX",
    rating: 5.0,
    reviews: 721,
    discountPrice: 1130,
    originalPrice: 1650,
    discountRate: 31,
    tag: "Limited Time Deal",
    inStock: true,
    coverImg: Moisturizer3,
    categoryName: "Moisturizers",
  },
  {
    _id: uuid(),
    name: "Sensibio Gel Moussant Foaming",
    brand: "Bioderma",
    rating: 4.5,
    reviews: 115,
    discountPrice: 421,
    originalPrice: 449,
    discountRate: 6,
    tag: "",
    inStock: true,
    coverImg: Cleanser1,
    categoryName: "Cleanser",
  },
  {
    _id: uuid(),
    name: "Hydrating Hyaluronic Cleanser",
    brand: "L'Oreal Paris",
    rating: 1.9,
    reviews: 205,
    discountPrice: 159,
    originalPrice: 175,
    discountRate: 9,
    tag: "",
    inStock: true,
    coverImg: Cleanser2,
    categoryName: "Cleanser",
  },
  {
    _id: uuid(),
    name: "Oil Free Grapefruit Acne Wash ",
    brand: "Neutrogena",
    rating: 2.7,
    reviews: 1239,
    discountPrice: 700,
    originalPrice: 700,
    discountRate: 0,
    tag: "",
    inStock: true,
    coverImg: Cleanser3,
    categoryName: "Cleanser",
  },
  {
    _id: uuid(),
    name: "In the Stars Shower Gel",
    brand: "Bath&Body Works",
    rating: 4.6,
    reviews: 2430,
    discountPrice: 699,
    originalPrice: 1399,
    discountRate: 50,
    tag: "Limited Time Deal",
    inStock: true,
    coverImg: Bodycare1,
    categoryName: "Bodycare",
  },
  {
    _id: uuid(),
    name: "Restful Moon Body Lotion",
    brand: "Bath&Body Works",
    rating: 3.9,
    reviews: 640,
    discountPrice: 1399,
    originalPrice: 1399,
    discountRate: 0,
    tag: "",
    inStock: true,
    coverImg: Bodycare2,
    categoryName: "Bodycare",
  },
  {
    _id: uuid(),
    name: "A Thousand Wishes Body Cream",
    brand: "Bath&Body Works",
    rating: 4.7,
    reviews: 237,
    discountPrice: 699,
    originalPrice: 1399,
    discountRate: 50,
    tag: "",
    inStock: true,
    coverImg: Bodycare3,
    categoryName: "Bodycare",
  },
  {
    _id: uuid(),
    name: "Icecream Cone Cake Soap",
    brand: "Sass Bar",
    rating: 4.2,
    reviews: 345,
    discountPrice: 250,
    originalPrice: 300,
    discountRate: 16,
    tag: "",
    inStock: true,
    coverImg: Bodycare4,
    categoryName: "Bodycare",
  },
  {
    _id: uuid(),
    name: "Blueberry Whipped Soap",
    brand: "Sass Bar",
    rating: 2.8,
    reviews: 278,
    discountPrice: 427,
    originalPrice: 450,
    discountRate: 5,
    tag: "",
    inStock: true,
    coverImg: Bodycare5,
    categoryName: "Bodycare",
  },
];
